import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { ItemWarning } from "./billItems";

export { AddRowButton, FieldError } from "../../../components/novarium/NvTableParts";

/** Íconos sueltos de la fila: editar (abre el detalle) y quitar (sin confirmación: se aplica al guardar). */
export function RowActions({ itemName, editLabel, onEdit, onRemove }: { itemName: string; editLabel: string; onEdit: () => void; onRemove: () => void }) {
    return (
        <span className="nv-cell-actions">
            <Button
                type="button"
                text
                className="nv-icon nv-tip"
                icon="pi pi-pencil"
                aria-label={`${editLabel}: ${itemName}`}
                data-pr-tooltip={editLabel}
                onClick={onEdit}
            />
            <Button
                type="button"
                text
                className="nv-icon nv-tip"
                icon="pi pi-trash"
                aria-label={`Quitar ${itemName}`}
                data-pr-tooltip="Quitar"
                onClick={onRemove}
            />
        </span>
    );
}

/** Primer aviso de la fila como tag con texto; si hay más, "+N" con el resto en el tooltip. */
export function WarningTags({ warnings }: { warnings: ItemWarning[] }) {
    if (warnings.length === 0) return <span className="nv-muted">—</span>;
    const [first, ...rest] = warnings;
    return (
        <span className="nv-tags">
            <Tag
                className={`nv-tip ${first.severity === 'err' ? 'nv-tag-err' : 'nv-tag-warn'}`}
                icon="pi pi-exclamation-triangle"
                value={first.label}
                data-pr-tooltip={first.detail}
                tabIndex={0}
            />
            {rest.length > 0 && (
                <Tag
                    className="nv-tip nv-tag-neutral"
                    value={`+${rest.length}`}
                    data-pr-tooltip={rest.map(w => w.label).join(', ')}
                    tabIndex={0}
                />
            )}
        </span>
    );
}

/** Fecha de aplicación tal como llega; las ISO ('YYYY-MM-DD') se muestran como d/m/aaaa. */
export function formatApplicationDate(value: string | null | undefined): string {
    if (!value) return '—';
    const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
    return iso ? `${Number(iso[3])}/${Number(iso[2])}/${iso[1]}` : value;
}

export const formatCoverage = (value: number | null | undefined): string =>
    value === null || value === undefined ? '—' : `${new Intl.NumberFormat('es-AR', { maximumFractionDigits: 2 }).format(value)}%`;
